/**
 *  UnifiedPOI provides unification between place and icon POIs.
 */

import * as R from 'ramda';

export const VIEWPOINT_PADDING = {
  top: 100,
  bottom: 100,
  left: 100,
  right: 100
};

// getOptions :: (String, Mapviewer) -> POIOptions
//    POIOptions = Object
export function getOptions (poiID, mapviewer) {
  const [poi] = getPOI(mapviewer)(poiID);
  return poi.options();
}

export const getPOI = mapviewer => id =>
  (mapviewer.getPOI(id) || [getErrorPOI(id)]);

export function getErrorPOI (id) {
  const error = new Error(`Non existing POI '${id}'`);
  return {
    hide () { console.error(error); },
    options () {
      console.error(error);
      return { isError: error };
    },
    isError: error
  };
}

export class UnifiedPOI {
  constructor(options) {
    this.id = options.id;
    this.options = options;
  }

  static toOptions (a, mapviewer) {
    switch (typeof a) {
    case 'string':
      return getOptions(a, mapviewer);
    case 'object':
      if (isArrayOfRawPOI(a)) {
        return a[0].options();
      }
      else if (isRawPOI(a)) {
        return a.options;
      }
      return a;
      // else if (isOptions(a)) {
      //   return a;
      // }
    }
  }

  // from :: a -> UnifiedPOI
  //    a = String|[POI]|POI|POIOptions
  static from (a, mapviewer) {
    const options = UnifiedPOI.toOptions(a, mapviewer);
    const isPlace = options.width > 0 && options.height > 0;
    return isPlace ? new PlacePOI(options) : new IconPOI(options);
  }
}

const isArrayOfRawPOI = R.pathEq([0, 'vg', 'poi'], true);
const isRawPOI = R.propIs(Function, 'options');
// const is3DPoint = R.where({ x: R.is(Number), y: R.is(Number), z: R.is(Number) });
// const isOptions = R.whereEq({
//   angle: R.is(Number),
//   clickable: R.is(Boolean),
//   color: R.is(Number),
//   face2d: R.is(Boolean),
//   fixed: R.is(Boolean),
//   flip: R.is(Boolean),
//   floor: R.is(String),
//   height: R.is(Number),
//   id: R.is(String),
//   position: is3DPoint,
//   scale: is3DPoint,
//   width: R.is(Number)
// });



export class PlacePOI extends UnifiedPOI {

  constructor(options) {
    super(options);
  }

  getViewpoint (mapviewer, padding = VIEWPOINT_PADDING) {
    const { id } = this.options;
    const points = mapviewer.getFootprintPoints(id);
    const viewpoint = mapviewer.getViewpointFromPositions(
      Object.assign({ points }, padding)
    );
    return viewpoint || mapviewer.camera.position;
  }
}

export class IconPOI extends UnifiedPOI {

  constructor(options) {
    super(options);
  }

  getViewpoint (mapviewer, radius = 150) {
    const { position } = this.options;
    return Object.assign({ radius }, position);
  }
}
